import React, { ComponentProps, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views,
} from '../../components/organisms/BlockInteractions';
import { Namespace } from '../../translation/namespace';
import { Icons } from '../../components/atoms/SVG';
import { copyHtml } from '../../lib/Clipboard/clipboardUtils';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, Views as BlockWithViews } from '../../types/BlockWithViews';
import { On2HtmlContainer } from './views/On2HtmlContainer';

const blockInteractionButtons = (wysiwygRef: React.RefObject<HTMLDivElement | null>) => {
  return {
    ...createButtonObject(
      Views.ACTION,
      Icons.COPY_PASTE,
      `${Namespace.On2Content}:buttons.copy`,
      DISPLAY_TYPE.NONE,
      null,
      null,
      false,
      false,
      copyHtml(wysiwygRef)
    ),
    ...createButtonObject(
      Views.DELETE,
      Icons.DELETE_TRASHCAN,
      `${Namespace.On2Content}:buttons.delete`,
      DISPLAY_TYPE.MODAL,
      null
    ),
  };
};

type On2ContentProps = BlockWithViews<DefaultView<On2HtmlContainer>>;

export function On2Content({ views }: On2ContentProps) {
  const { uuid, elementType } = useBlockContext();
  const { html, resourceReferencesToToUrls, partialBlocks } = views.default.embedded;

  const wysiwygRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation(Namespace.On2Content);

  if (!html) {
    return null;
  }

  return (
    <BlockInteractions
      headline={{
        text: t('headline'),
        hierarchy: 3,
        visible: true,
      }}
      buttons={blockInteractionButtons(wysiwygRef)}
      views={views}
      uuid={uuid}
      elementType={elementType}
    >
      <On2HtmlContainer
        ref={wysiwygRef}
        html={html}
        resourceReferencesToToUrls={resourceReferencesToToUrls}
        partialBlocks={partialBlocks}
      />
    </BlockInteractions>
  );
}

export const On2ContentBlock = asFetchableBlock(On2Content, BlockType.on2content);
export type On2ContentBlock = ComponentProps<typeof On2ContentBlock>;
